import cookie from "js-cookie";

export const setCookieHandler = (key, value) => cookie.set(
    key,
    value,
);

export const removeCookieHandler = (key) => cookie.remove(key);

export const getCookieHandler = (key) => cookie.get(key);
